import { Divider } from "antd"
import { CompanyIcon } from "../../atoms"
import { techCompanyIcons } from "./types"
import { CompanyIconsWrapper, HeadlineText, TechDescription } from "./styles"
import { StyledGradientTitle } from "../../../utils"

const TechInfo = () => {
  return (
    <TechDescription>
      <HeadlineText>
        {"Who are we as "}
        <StyledGradientTitle>{"tech-company?"}</StyledGradientTitle>
      </HeadlineText>
      <p className={"info"}>
        {`We are Japan based software company ready to challenge every problems with our tech expertise. We promote co-creation, and support system development for a wide range of customers, from major companies to startups and local governments.`}
      </p>
      <p className={"info"}>
        {`Driven by a commitment to quality and innovation, we deliver scalable, reliable, and future-ready solutions tailored to each client’s unique needs. Our team works closely with partners to turn ideas into impactful digital experiences.`}
      </p>
      <CompanyIconsWrapper>
        {techCompanyIcons?.map((icon, i) => {
          return (
            <div key={i} className={"company-icons"}>
              <CompanyIcon
                icon={icon?.icon}
                lightIcon={icon?.lightIcon}
                name={icon?.name}
              />
              {i != 2 && <Divider type={"vertical"} className={"divider"} />}
            </div>
          )
        })}
      </CompanyIconsWrapper>
    </TechDescription>
  )
}

export default TechInfo
